import { render } from "./SingleSelect.vue?vue&type=template&id=91051992"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script